import React from 'react';
import { CheckCircle, XCircle, Package, X } from 'lucide-react';

export default function BulkActionsPanel({ selectedCount, onBulkStatusUpdate, onClearSelection }) {
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <span className="text-sm font-medium text-gray-900">
            {selectedCount} réservation{selectedCount > 1 ? 's' : ''} sélectionnée{selectedCount > 1 ? 's' : ''}
          </span>
          <div className="flex items-center space-x-2">
            <button
              onClick={() => onBulkStatusUpdate('confirmed')}
              className="flex items-center space-x-2 px-3 py-1.5 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm"
            >
              <CheckCircle size={16} />
              <span>Confirmer</span>
            </button>
            <button
              onClick={() => onBulkStatusUpdate('processing')}
              className="flex items-center space-x-2 px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm"
            >
              <Package size={16} />
              <span>En Traitement</span>
            </button>
            <button
              onClick={() => onBulkStatusUpdate('completed')}
              className="flex items-center space-x-2 px-3 py-1.5 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors text-sm"
            >
              <CheckCircle size={16} />
              <span>Terminé</span>
            </button>
            <button
              onClick={() => onBulkStatusUpdate('cancelled')}
              className="flex items-center space-x-2 px-3 py-1.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm"
            >
              <XCircle size={16} />
              <span>Annuler</span>
            </button>
          </div>
        </div>
        <button
          onClick={onClearSelection}
          className="flex items-center space-x-2 px-3 py-1.5 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors text-sm"
        >
          <X size={16} />
          <span>Effacer</span>
        </button>
      </div>
    </div>
  );
}